import { useDispatch, useSelector } from 'react-redux';
import { ReactSortable } from 'react-sortablejs';
import useTranslation from '../../../../hooks/useTranslations';
import { openFavoritesFormModal, selectFavoriteListsWithObjects, selectIPadFavoriteLists, setFavoriteLists } from '../../../../redux/modules/favoritesSlice';
import { AlertIcon } from '../../../misc/icons/Icons';
import ContentWrapper from '../../layouts/partials/ContentWrapper';
import SidebarWrapper from '../../layouts/partials/SidebarWrapper';
import TableWrapper from '../../layouts/partials/TableWrapper';
import PrivateLayout from '../../layouts/PrivateLayout';
import FavoriteRow from './partials/FavoriteRow';

const FavoritesScreen = () => {
	const t = useTranslation();
	const dispatch = useDispatch();

	const tempFavoriteLists = useSelector((state) => selectFavoriteListsWithObjects(state));
	const iPadFavoriteLists = useSelector((state) => selectIPadFavoriteLists(state));
	const breadcrumb = [{ route: 'favorites', translationKey: 'favorites_headline' }];

	const openModal = () => {
		dispatch(openFavoritesFormModal());
	};

	return (
		<PrivateLayout customTree={breadcrumb}>
			<SidebarWrapper title={t('favorites_headline')} customTree={breadcrumb}>
				<div className="text-white border border-white text-[0.84375rem] lg:text-[1.0625rem] mb-6 lg:my-24 px-4 lg:px-5 py-2 lg:py-3 -mx-5 max-w-xs">
					<div className="flex justify-between">
						<span className="font-bold">
							{t('webapp_favs_note_headline')}
						</span>
						<AlertIcon className="flex-shrink-0 w-5 h-5 ml-2 -mr-2 lg:-mt-1 lg:w-6 lg:h-6 text-oly-red-default" />
					</div>
					<p>
						{t('webapp_favs_note_text')}
					</p>
				</div>
			</SidebarWrapper>
			<ContentWrapper>
				<TableWrapper buttons={[{ id: 1, title: t('favorites_button_new'), handleClick: () => openModal() }]} title={!tempFavoriteLists?.length > 0 && iPadFavoriteLists && !iPadFavoriteLists?.length > 0 ? t('favorite_lists_empty') : ''}>
					{tempFavoriteLists?.length > 0 && (
						<ReactSortable
							list={tempFavoriteLists}
							setList={(params) => { dispatch(setFavoriteLists({ favoriteLists: params })); }}
							className="border-t-0.5 border-b-0.5 divide-y divide-oly-gray-light border-oly-gray-light"
							ghostClass="ghost-class"
							handle=".drag-control"
						>
							{tempFavoriteLists.map((tempFavList) => <FavoriteRow id={tempFavList.id} key={tempFavList.id} title={tempFavList.title} created={tempFavList.created} size={tempFavList.size} count={tempFavList.objectIds.length} />)}
						</ReactSortable>
					)}
					{(iPadFavoriteLists && iPadFavoriteLists?.length > 0) && (
						<div className={`${tempFavoriteLists?.length > 0 ? 'pt-16 lg:pt-22' : 'pt-4 lg:pt-6'}`}>
							<div className="pl-4 sm:pl-10">
								<span className="text-[1.125rem] sm:text-[1.5rem] font-semibold text-oly-gray-darkest">
									{t('webapp_favs_saved')}
								</span>
							</div>
							<div className="mt-4 border-t-0.5 border-b-0.5 divide-y divide-oly-gray-light border-oly-gray-light">
								{iPadFavoriteLists.map((padFavList) => <FavoriteRow id={padFavList.id} key={padFavList.id} title={padFavList.title} created={padFavList.created} size={padFavList.size} count={padFavList.objectIds.length} hideButtons />)}
							</div>
						</div>
					)}
				</TableWrapper>
			</ContentWrapper>
		</PrivateLayout>
	);
};

export default FavoritesScreen;
